import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { TradingRepo as tradingRepo } from '@services/trading.repo';
import { tradingAdmin } from './tradingadmin';
import { adminTradeSheets } from './tradesheets/admintradesheets';
import { completeTradeSheetDialog } from './tradesheets/completeTradeSheetDialog/completeTradeSheet.dialog';
import { cancelTradeSheetDialog } from './tradesheets/cancelTradeSheetDialog/cancelTradeSheet.dialog';


export const tradingAdminModule = 'tradingAdmin';

angular
  .module(tradingAdminModule, ['xeditable'])
  .constant("config", constants.Default)
  .service('tradingRepo', tradingRepo)
  .component('tradingAdmin',tradingAdmin)
  .component('adminTradeSheets',adminTradeSheets)
  .component('completeTradeSheetDialog',completeTradeSheetDialog)
  .component('cancelTradeSheetDialog',cancelTradeSheetDialog)



// WEBPACK FOOTER //
// ./src/app/tradingadmin/tradingAdmin.index.ts